import * as React from 'react';
import { createPortal } from 'react-dom';
import { IconClose16, UIHeading4 } from '@cian/ui-kit';

import * as styles from './FullscreenHeader.css';

export interface IFullscreenHeaderProps {
  name: string;
  phoneButton: React.ReactNode;
  callbackButton: React.ReactNode;
  onClose(): void;
}

export function FullscreenHeader({ name, phoneButton, onClose, callbackButton }: IFullscreenHeaderProps) {
  return createPortal(
    <div className={styles['controls']}>
      <div className={styles['title']}>
        <UIHeading4 color="white_100">{name}</UIHeading4>
      </div>
      <div className={styles['actions']}>
        {phoneButton}
        {callbackButton}
      </div>
      <button className={styles['close']} data-name="CloseButton" onClick={onClose}>
        <IconClose16 color="white_100" display="block" />
      </button>
    </div>,
    document.body,
  );
}
